import styled from 'styled-components';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IconImage = styled.img<any>`
  width: 16px;
`;
